var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdditional(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 21.563 23.906",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "_x31_4_application_documents"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_239_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_260_",
    d: "m21.094 0h-18.75c-0.259 0 -0.469 0.21 -0.469 0.469v2.344h-1.406c-0.259 0 -0.469 0.21 -0.469 0.469v20.156c0 0.259 0.21 0.469 0.469 0.469h17.813c0.259 0 0.469 -0.21 0.469 -0.469v-1.406h2.344c0.259 0 0.469 -0.21 0.469 -0.469v-21.094c0 -0.259 -0.21 -0.469 -0.469 -0.469zm-3.281 22.969h-16.875v-19.219h16.875zm2.813 -1.875h-1.875v-17.813c0 -0.259 -0.21 -0.469 -0.469 -0.469h-15.469v-1.875h17.813z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_269_",
    d: "m8.906 6.563c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-6.094c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_270_",
    d: "m8.906 13.594h6.094c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-6.094c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_271_",
    d: "m8.438 17.344h-5.156c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h5.156c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_272_",
    d: "m9.844 8.906h6.094c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-6.094c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_273_",
    d: "m9.844 10.781c0 -0.259 -0.21 -0.469 -0.469 -0.469h-6.094c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h6.094c0.259 0 0.469 -0.21 0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_279_",
    d: "m14.531 16.875c-1.292 0 -2.344 1.051 -2.344 2.344s1.051 2.344 2.344 2.344 2.344 -1.051 2.344 -2.344 -1.051 -2.344 -2.344 -2.344zm0 3.75c-0.775 0 -1.406 -0.631 -1.406 -1.406s0.631 -1.406 1.406 -1.406 1.406 0.631 1.406 1.406 -0.631 1.406 -1.406 1.406z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_280_",
    d: "m12.656 6.563h3.281c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-3.281c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_281_",
    d: "m7.031 8.906c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-3.281c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_282_",
    d: "m14.531 11.25c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469h-2.344c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_283_",
    d: "m3.75 12.656c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h2.813c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_284_",
    d: "m16.406 15h-2.813c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h2.813c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_285_",
    d: "m8.438 19.688h-2.813c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h2.813c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_407_",
    d: "m11.25 15h-7.969c-0.259 0 -0.469 0.21 -0.469 0.469s0.21 0.469 0.469 0.469h7.969c0.259 0 0.469 -0.21 0.469 -0.469s-0.21 -0.469 -0.469 -0.469z",
    fill: "#E11B22",
    "data-original": "#000000",
    className: ""
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdditional);
export default __webpack_public_path__ + "static/media/additional.b56923684f73123c9ed7d74072a9a4b9.svg";
export { ForwardRef as ReactComponent };